import { BookingCard } from "./BookingCard";
import { Col, Row } from "antd";
import { MiniReservationCard } from "views/mobile/components/cards/MiniReservationCard";
import { useCancelReservation } from "state/reservations/hooks";
import React from "react";

export const BookingList = ({ bookings, justify = "start" }) => {
	return (
		<Row justify={justify} align="middle" gutter={24}>
			{bookings.map((booking) => (
				<Col key={booking.id}>
					<BookingCard booking={booking}></BookingCard>
				</Col>
			))}
		</Row>
	);
};

export const BookingList2 = ({ reservation }) => {
	return (
		<Col key={reservation.id}>
			<MiniReservationCard reservation={reservation} />
		</Col>
	);
};
